export interface BehfaRole_Interface {
  id:number,
  title:string,
  dsc:string,
  create_user:String,
  create_date:String,
  update_user:String,
  update_date:String,
  del:boolean,
  deletingProccess:boolean,
}

export function Empty_BehfaRole_Interface():BehfaRole_Interface{
  return{
    id:0,
    title:'',
    dsc:'',
    create_user:'',
    create_date:'',
    update_user:'',
    update_date:'',
    del:false,
    deletingProccess:false,
  }
}
